import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get } from "../../services/api";
import { status } from "../../helpers/statusVariable";
import { getStations } from "../../helpers/companiesNormalized";
import { success } from "../../helpers/messages";
import { SUCCESS, WARNING } from "../../utils/colorsTheme";
import {openSnackbar} from "./globalSnackbar";

// data
const LOAD_DATA_ORDERS_HISTORY = "LOAD_DATA_ORDERS_HISTORY";
const SET_DATA_ORDERS_HISTORY = "SET_DATA_ORDERS_HISTORY";
const ERROR_DATA_ORDERS_HISTORY = "ERROR_DATA_ORDERS_HISTORY";

// orders
const LOAD_ORDERS_ORDERS_HISTORY = "LOAD_ORDERS_ORDERS_HISTORY";
const SET_ORDERS_ORDERS_HISTORY = "SET_ORDERS_ORDERS_HISTORY";
const ERROR_ORDERS_ORDERS_HISTORY = "ERROR_ORDERS_ORDERS_HISTORY";

// orders on table
const ADD_ORDER_SELECTED_ORDERS_HISTORY = "ADD_ORDER_SELECTED_ORDERS_HISTORY";
const ADD_ORDERS_SELECTED_ORDERS_HISTORY = "ADD_ORDERS_SELECTED_ORDERS_HISTORY";
const REMOVE_ORDER_SELECTED_ORDERS_HISTORY =
  "REMOVE_ORDER_SELECTED_ORDERS_HISTORY";
const REMOVE_ORDERS_SELECTED_ORDERS_HISTORY =
  "REMOVE_ORDERS_SELECTED_ORDERS_HISTORY";
const CLEAR_ORDERS_SELECTED_ORDERS_HISTORY =
  "CLEAR_ORDERS_SELECTED_ORDERS_HISTORY";

// Open close info marker
const OPEN_ORDER_SELECTED_ORDERS_HISTORY = "OPEN_ORDER_SELECTED_ORDERS_HISTORY";
const CLOSE_ORDER_SELECTED_ORDERS_HISTORY =
  "CLOSE_ORDER_SELECTED_ORDERS_HISTORY";

// detail
const LOAD_DETAIL_ORDERS_HISTORY = "LOAD_DETAIL_ORDERS_HISTORY";
const SET_DETAIL_ORDERS_HISTORY = "SET_DETAIL_ORDERS_HISTORY";
const ERROR_DETAIL_ORDERS_HISTORY = "ERROR_DETAIL_ORDERS_HISTORY";
const CLEAR_DETAIL_ORDERS_HISTORY = "CLEAR_DETAIL_ORDERS_HISTORY";

// Postsale
const LOAD_POSTSALE_ORDERS_HISTORY = "LOAD_POSTSALE_ORDERS_HISTORY";
const SET_POSTSALE_ORDERS_HISTORY = "SET_POSTSALE_ORDERS_HISTORY";
const ERROR_POSTSALE_ORDERS_HISTORY = "ERROR_POSTSALE_ORDERS_HISTORY";

// filters
const CHANGE_STATION_ORDERS_HISTORY = "CHANGE_STATION_ORDERS_HISTORY";
const CHANGE_START_DATE_ORDERS_HISTORY = "CHANGE_START_DATE_ORDERS_HISTORY";
const CHANGE_END_DATE_ORDERS_HISTORY = "CHANGE_END_DATE_ORDERS_HISTORY";

// general
const CLEAR_ORDERS_HISTORY = "CLEAR_DATA_ORDERS_HISTORY";
const CLEAR_ERROR_ORDERS_HISTORY = "CLEAR_ERROR_ORDERS_HISTORY";
const CLEAR_SUCCESS_ORDERS_HISTORY = "CLEAR_SUCCESS_ORDERS_HISTORY";
const SET_ERROR_ORDERS_HISTORY = "SET_ERROR_ORDERS_HISTORY";

const INITIAL_STATE = {
  orders: [],
  ordersMap: {},
  ordersSelected: [],
  ordersIDSelected: [],

  companies: [],
  stations: [],
  isLoading: false,
  colorSnackbar: SUCCESS,
  error: false,
  success: false,
  message: "",
  errorMessage: "",
  isLoadingOrders: false,
  // filters
  startDate: null,
  endDate: null,
  stationSelected: "",
  nameStation: "",
  companyStations: [],
  // detail info
  isLoadingDetailInfo: false,
  detail: null,
  // postsale
  isLoadingPostsale: false,
};

const ordersHistoryReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOAD_DATA_ORDERS_HISTORY:
      return {
        ...state,
        companies: [],
        stations: [],
        isLoading: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case SET_DATA_ORDERS_HISTORY:
      return {
        ...state,
        companies: payload.companies,
        stations: payload.stations,
        isLoading: false,
      };
    case ERROR_DATA_ORDERS_HISTORY:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };

    case LOAD_ORDERS_ORDERS_HISTORY:
      return {
        ...state,
        orders: [],
        ordersMap: {},
        ordersSelected: [],
        ordersIDSelected: [],
        isLoadingOrders: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case SET_ORDERS_ORDERS_HISTORY:
      return {
        ...state,
        orders: payload.orders,
        ordersMap: payload.ordersMap,
        isLoadingOrders: false,
      };
    case ERROR_ORDERS_ORDERS_HISTORY:
      return {
        ...state,
        isLoadingOrders: false,
        error: true,
        errorMessage: payload.message,
      };

    // Orders on table
    case ADD_ORDER_SELECTED_ORDERS_HISTORY:
      const ordersToAdd = [...state.orders];
      const indexAdd = ordersToAdd.findIndex(
        (order) => order.id === payload.id
      );

      if (indexAdd !== -1) {
        ordersToAdd[indexAdd].isSelected = true;
      }

      return {
        ...state,
        orders: ordersToAdd,
        ordersSelected: [...state.ordersSelected, payload.order],
      };
    case ADD_ORDERS_SELECTED_ORDERS_HISTORY:
      const newOrders = [...state.orders];
      const newIdsToAdd = [];
      const newOrdersToAdd = [];

      payload.orders.forEach((orderPayload) => {
        const indexOrder = newOrders.findIndex(
          (order) => order.id === orderPayload.id
        );
        if (
          indexOrder !== -1 &&
          !state.ordersIDSelected.includes(newOrders[indexOrder].id)
        ) {
          newOrders[indexOrder].isSelected = true;
          newIdsToAdd.push(newOrders[indexOrder].id);
          newOrdersToAdd.push({ ...newOrders[indexOrder], isOpen: false });
        }
      });

      return {
        ...state,
        orders: newOrders,
        ordersSelected: [...state.ordersSelected, ...newOrdersToAdd],
        ordersIDSelected: [...state.ordersIDSelected, ...newIdsToAdd],
      };
    case REMOVE_ORDERS_SELECTED_ORDERS_HISTORY:
      const newOrdersToRemove = [...state.orders];
      const newOrdersSelectedToRemove = [...state.ordersSelected];
      const indexesToRemove = [];
      const idsToRemove = [];

      payload.orders.forEach((orderPayload) => {
        const indexOrder = newOrdersToRemove.findIndex(
          (order) => order.id === orderPayload.id
        );
        const indexOrderSelected = newOrdersSelectedToRemove.findIndex(
          (order) => order.id === orderPayload.id
        );

        if (indexOrder !== -1) {
          indexesToRemove.push(indexOrder);
          idsToRemove.push(newOrdersToRemove[indexOrder].id);
          newOrdersToRemove[indexOrder].isSelected = false;
        }
        if (indexOrderSelected !== -1) {
          newOrdersSelectedToRemove[indexOrderSelected].isSelected = false;
        }
      });

      return {
        ...state,
        orders: newOrdersToRemove,
        ordersSelected: newOrdersSelectedToRemove.filter(
          (order) => order.isSelected
        ),
        ordersIDSelected: state.ordersIDSelected.filter(
          (id) => !idsToRemove.includes(id)
        ),
      };

    case REMOVE_ORDER_SELECTED_ORDERS_HISTORY:
      const ordersToRemove = [...state.orders];
      const indexRemove = ordersToRemove.findIndex(
        (order) => order.id === payload.id
      );

      if (indexAdd !== -1) {
        ordersToRemove[indexRemove].isSelected = false;
      }

      return {
        ...state,
        orders: ordersToRemove,
        ordersSelected: indexRemove
          ? state.ordersSelected.splice(indexRemove, 1)
          : state.ordersSelected,
        ordersIDSelected: [...state.ordersIDSelected, ...newIdsToAdd],
      };

    // open close info

    case OPEN_ORDER_SELECTED_ORDERS_HISTORY:
      const ordersToOpen = [...state.ordersSelected];
      const indexToOpen = ordersToOpen.findIndex(
        (order) => order.id === payload.id
      );

      if (indexToOpen !== -1) {
        ordersToOpen[indexToOpen].isOpen = true;
      }

      return {
        ...state,

        ordersSelected: ordersToOpen,
      };
    case CLOSE_ORDER_SELECTED_ORDERS_HISTORY:
      const ordersToClose = [...state.ordersSelected];
      const indexToClose = ordersToClose.findIndex(
        (order) => order.id === payload.id
      );

      if (indexToClose !== -1) {
        ordersToClose[indexToClose].isOpen = false;
      }

      return {
        ...state,
        ordersSelected: ordersToClose,
      };

    case CLEAR_ORDERS_SELECTED_ORDERS_HISTORY:
      return {
        ...state,
        ordersSelected: [],
      };

    // Detail
    case LOAD_DETAIL_ORDERS_HISTORY:
      return {
        ...state,
        detail: null,
        isLoadingDetailInfo: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case SET_DETAIL_ORDERS_HISTORY:
      return {
        ...state,
        detail: payload.detail,
        isLoadingDetailInfo: false,
      };
    case ERROR_DETAIL_ORDERS_HISTORY:
      return {
        ...state,
        isLoadingDetailInfo: false,
        error: true,
        errorMessage: payload.message,
      };
    case CLEAR_DETAIL_ORDERS_HISTORY:
      return {
        ...state,
        detail: null,
        isLoadingDetailInfo: false,
        error: false,
        errorMessage: "",
      };

    // Postsale
    case LOAD_POSTSALE_ORDERS_HISTORY:
      return {
        ...state,
        isLoadingPostsale: true,
        error: false,
        success: false,
        message: "",
        errorMessage: "",
      };
    case SET_POSTSALE_ORDERS_HISTORY:
      const ordersPostsale = [...state.orders];

      const indexPostsale = ordersPostsale.findIndex(
        (order) => order.id === payload.id
      );

      if (indexPostsale !== -1) {
        ordersPostsale[indexPostsale].posSale = payload.posSale;
      }

      return {
        ...state,
        orders: ordersPostsale,
        isLoadingPostsale: false,
        success: true,
        message: payload.message,
        colorSnackbar: payload.color,
      };
    case ERROR_POSTSALE_ORDERS_HISTORY:
      return {
        ...state,
        isLoadingPostsale: false,
        error: true,
        success: false,
        errorMessage: payload.message,
      };

    case CHANGE_STATION_ORDERS_HISTORY:
      return {
        ...state,
        stationSelected: payload,
      };
    case CHANGE_START_DATE_ORDERS_HISTORY:
      return {
        ...state,
        startDate: payload,
      };
    case CHANGE_END_DATE_ORDERS_HISTORY:
      return {
        ...state,
        endDate: payload,
      };

    case CLEAR_ORDERS_HISTORY:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case CLEAR_ERROR_ORDERS_HISTORY:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    case CLEAR_SUCCESS_ORDERS_HISTORY:
      return {
        ...state,
        success: false,
        message: "",
      };
    case SET_ERROR_ORDERS_HISTORY:
      return {
        ...state,
        error: true,
        errorMessage: payload,
      };

    default:
      return state;
  }
};

// Actions
function getData() {
  return {
    type: LOAD_DATA_ORDERS_HISTORY,
  };
}
function getOrders(stations, startDate, endDate, type) {
  return {
    type: LOAD_ORDERS_ORDERS_HISTORY,
    payload: {
      stations,
      startDate,
      endDate,
      type,
    },
  };
}
function getDetail(id) {
  return {
    type: LOAD_DETAIL_ORDERS_HISTORY,
    payload: {
      id,
    },
  };
}
function getPostsale(id) {
  return {
    type: LOAD_POSTSALE_ORDERS_HISTORY,
    payload: {
      id,
    },
  };
}
// Orders on Table
function addOrderSelected(order, id) {
  return {
    type: ADD_ORDER_SELECTED_ORDERS_HISTORY,
    payload: {
      id,
      order,
    },
  };
}
function addOrdersSelected(orders) {
  return {
    type: ADD_ORDERS_SELECTED_ORDERS_HISTORY,
    payload: {
      orders,
    },
  };
}
function removeOrdersSelected(orders) {
  return {
    type: REMOVE_ORDERS_SELECTED_ORDERS_HISTORY,
    payload: {
      orders,
    },
  };
}
function removeOrderSelected(order, id) {
  return {
    type: REMOVE_ORDER_SELECTED_ORDERS_HISTORY,
    payload: {
      id,
      order,
    },
  };
}

// open close info
function openOrder(id) {
  return {
    type: OPEN_ORDER_SELECTED_ORDERS_HISTORY,
    payload: {
      id,
    },
  };
}
function closeOrder(id) {
  return {
    type: CLOSE_ORDER_SELECTED_ORDERS_HISTORY,
    payload: {
      id,
    },
  };
}

function changeStation(station) {
  return {
    type: CHANGE_STATION_ORDERS_HISTORY,
    payload: station,
  };
}
function changeStartDate(date) {
  return {
    type: CHANGE_START_DATE_ORDERS_HISTORY,
    payload: date,
  };
}
function changeEndDate(date) {
  return {
    type: CHANGE_END_DATE_ORDERS_HISTORY,
    payload: date,
  };
}
function setError(error) {
  return {
    type: SET_ERROR_ORDERS_HISTORY,
    payload: error,
  };
}
function clearDetail() {
  return {
    type: CLEAR_DETAIL_ORDERS_HISTORY,
  };
}
function clearError() {
  return {
    type: CLEAR_ERROR_ORDERS_HISTORY,
  };
}
function clearSuccess() {
  return {
    type: CLEAR_SUCCESS_ORDERS_HISTORY,
  };
}

// sagas
function* fetchData() {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  try {
    const response = yield call(api_get, url, auth);

    const stations = getStations(response.companies);

    const stationsNormalized = stations.map((station) => {
      return { value: station.id, label: station.name };
    });

    yield put({
      type: SET_DATA_ORDERS_HISTORY,
      payload: {
        companies: response.companies,
        stations: stationsNormalized,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_DATA_ORDERS_HISTORY,
      payload: {
        message,
      },
    });
  }
}
function* fetchOrders(action) {
  const {
    payload: { stations = [], startDate, endDate, type },
  } = action;
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/notes?`;

  let urlStations = `start=${startDate}&end=${endDate}&type=${type}`;

  if (stations) {
    stations.forEach((station) => {
      urlStations = `${urlStations}&idStation=${station.value}`;
    });
  }
  const url = `${baseUrl}${urlStations}`;

  try {
    let response = yield call(api_get, url, auth);

    response = response.map((order) => {
      return {
        ...order,
        status: status[order.status.toUpperCase()],
        isSelected: false,
      };
    });

    yield put({
      type: SET_ORDERS_ORDERS_HISTORY,
      payload: {
        orders: response,
        ordersMap: {},
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_ORDERS_ORDERS_HISTORY,
      payload: {
        message,
      },
    });
  }
}
function* fetchDetail(action) {
  const {
    payload: { id },
  } = action;
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/${id}/details`;

  try {
    const response = yield call(api_get, url, auth);
    yield put({
      type: SET_DETAIL_ORDERS_HISTORY,
      payload: {
        detail: response,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_DETAIL_ORDERS_HISTORY,
      payload: {
        message,
      },
    });
  }
}
function* fetchPostsale(action) {
  const {
    payload: { id },
  } = action;
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/marketing/pos_sale/${id}`;

  try {
    const response = yield call(api_get, url, auth);
    const orderPossale = {
      url: response.url,
      user: response.user,
      send: response.send,
    };

    const successMessage = response.send
      ? success.postsaleSend
      : success.postsale;

    const colorMessage = response.send ? SUCCESS : WARNING;

    yield put({
      type: SET_POSTSALE_ORDERS_HISTORY,
      payload: {
        id,
        message: successMessage,
        color: colorMessage,
        posSale: orderPossale,
      },
    });
  } catch (e) {
    yield put(openSnackbar(e, "danger"));
    yield put({
      type: ERROR_POSTSALE_ORDERS_HISTORY,
      payload: {
        message: e,
      },
    });
  }
}

function* ordersHistorySaga() {
  yield takeLatest(LOAD_DATA_ORDERS_HISTORY, fetchData);
  yield takeLatest(LOAD_ORDERS_ORDERS_HISTORY, fetchOrders);
  yield takeLatest(LOAD_DETAIL_ORDERS_HISTORY, fetchDetail);
  yield takeLatest(LOAD_POSTSALE_ORDERS_HISTORY, fetchPostsale);
}

export {
  // reducer
  ordersHistoryReducer,
  // actions
  getData,
  getOrders,
  getDetail,
  getPostsale,
  addOrderSelected,
  addOrdersSelected,
  removeOrderSelected,
  removeOrdersSelected,
  openOrder,
  closeOrder,
  changeStation,
  changeStartDate,
  changeEndDate,
  setError,
  clearError,
  clearSuccess,
  clearDetail,
  // saga
  ordersHistorySaga,
};
